import axios from '@/utils/request'

export default {
    promotionAdd: (data) => axios({ url: '/api/product/discount/discount', method: 'post', data }), // 创建促销活动
    promotionEdit: (data) => axios({ url: '/api/product/discount/discount', method: 'put', data }), // 编辑促销活动
    promotionGetProductList: (data) => axios({ url: '/api/product/manage/list', method: 'post', data }), // 后台获取商品列表
    promotionGetDetailProduct: (params) => axios({ url: '/api/product/discount/discountDetailProduct', method: 'get', params }), // 获取促销活动详情产品列表
    promotionGetDiscountList: (data) => axios({ url: '/api/product/open/discount/getDiscountList', method: 'post', data }), // 获取促销活动列表
    promotionDiscountStatusChange: (data) => axios({ url: '/api/product/discount/discountStatus', method: 'put', data }), // 更新促销活动状态
    promotionDiscountDetail: (id) => axios({ url: `/api/product/discount/discountDetail/${id}`, method: 'get' }), // 获取促销活动详情
    promotionProductDelete: (data) => axios({ url: `/api/product/discount/discountProduct`, method: 'delete', data }), // 删除促销活动中的产品
    promotionProductDeleteLevel: (data) => axios({ url: `/api/product/discount/discountProductSort`, method: 'put', data }), // 删除促销活动中的产品

    promotionProductDiscountConfig: params => axios({ url: `/api/product/open/discount/config`, method: 'get', params }), // 删除促销活动中的产品
}
